import React from 'react';
import { formatReqUser } from '../../../util';

export function ReqUser(props) {
    const { user } = props;
    return user ? <>{formatReqUser(user)}</> : null;
}
